import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { Card, Stack, Typography } from '@mui/material';
import { Badge } from 'framework/ui/mui-builder';
import { ActionIconButton } from 'framework/ui/ui-builder';
import OwnersList from '../../components/OwnersList/OwnersList';
import SlaIndicator from '../../components/SlaIndicator/SlaIndicator';
import type { ObjectDetailsHeaderProps } from './types';

const ObjectDetailsHeader = ({
  title,
  badges,
  attributes,
  owners,
  renderOwner,
  slaEndDate,
  actions,
}: ObjectDetailsHeaderProps) => {
  const hasContent = title || badges?.length || attributes?.length || owners?.length || slaEndDate || actions?.length;

  if (!hasContent) return null;

  return (
    <Card sx={{ py: 1, px: 1.5 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
        <Stack direction="row" alignItems="center" columnGap={3} rowGap={1} flexWrap="wrap">
          {title && (
            <Typography variant="h1" color="brand">
              {title}
            </Typography>
          )}
          {badges?.map(badge => (
            <Badge key={badge.id} color={badge.color}>
              {badge.label}
            </Badge>
          ))}
          {attributes
            ?.filter(item => Boolean(item.value))
            .map(item => (
              <Typography key={item.id} variant="body2">
                {item.value}
              </Typography>
            ))}
          {owners?.length ? (
            <OwnersList
              owners={owners}
              renderOwner={renderOwner}
              icon={<PersonOutlineOutlinedIcon color="action" sx={{ fontSize: 16 }} />}
            />
          ) : null}
          {slaEndDate ? <SlaIndicator endDate={slaEndDate} variant="plain" /> : null}
        </Stack>
        {!!actions?.length && (
          <Stack direction="row" gap={1}>
            {actions.map(action => (
              <ActionIconButton key={action.id} {...action} />
            ))}
          </Stack>
        )}
      </Stack>
    </Card>
  );
};

export default ObjectDetailsHeader;
